(function () {
  'use strict';

  if (window.__productAgotadoInit) return;
  window.__productAgotadoInit = true;

  var OVERLAY_CLASS = 'pa-agotado-overlay';
  var MEDIA_CLASS = 'pa-agotado-media';
  var SOLD_OUT_RE = /sold\s*out|agotad[oa]|épuisé|ausverkauft|esaurito|rupture/i;

  var availabilityCache = {};
  var pendingHandles = {};

  var THUMB_PARENT_SELECTORS = [
    '.thumbnail-list',
    '.thumbnails',
    '.product__thumbs',
    '.product__media-sublist',
    '.slider-component--thumbnail',
    '.product__media-list--desktop-thumbnails',
    '.product__media-list--mobile-thumbnails',
    '.media-gallery__thumbnails',
    '.product-thumbnails',
    '.product-single__thumbnails',
    '[data-thumbnail-slider]',
    '[id*="thumbnail"]',
    '[id*="Thumb"]',
    '[data-pf-type="MediaList2"]',
    '[data-pf-type="MediaListItem2"]',
    '.pf-list-media',
    '.pf-slide-list-media'
  ];

  var PAGEFLY_MAIN_SELECTORS = [
    '[data-pf-type="MediaMain2"]',
    '[data-pf-type="MediaMain"]',
    '.pf-main-media-wrapper',
    '.pf-main-media'
  ];

  var PAGEFLY_CARD_SELECTORS = [
    '[data-pf-type="ProductBox"]',
    '[data-pf-type="ProductListItem"]',
    '[data-pf-type="ProductMedia"]',
    '[data-pf-type="ProductImage"]',
    '[data-pf-type="Column"]'
  ];

  var EXCLUDE_SCOPE_SELECTORS = [
    'header',
    'footer',
    '.related-products',
    '.product-recommendations',
    '.complementary-products',
    '.recently-viewed',
    '.product-recently-viewed',
    '[id*="Recommend"]',
    '[class*="recommend"]',
    '[class*="related"]',
    '.cart-drawer',
    '.search-modal'
  ];

  var CARD_SELECTORS = [
    '[data-pf-type="ProductBox"]',
    '[data-pf-type="ProductListItem"]',
    '.pf-main-media-wrapper',
    '.product-card',
    '.card--product',
    '.card-wrapper.product-card-wrapper',
    '.grid__item .card',
    '[data-product-id]',
    'li.grid__item',
    '.collection-product-card',
    '.product-grid__item',
    '.product-item',
    '.product-block',
    '.snize-product',
    '.boost-pfs-filter-product-item'
  ];

  var CARD_MEDIA_SELECTORS = [
    '[data-pf-type="MediaMain2"]',
    '[data-pf-type="MediaMain"]',
    '[data-pf-type="ProductMedia"]',
    '[data-pf-type="ProductImage"]',
    '.pf-main-media-wrapper',
    '.pf-main-media',
    '.card__media',
    '.product-card__figure',
    '.product-card__image',
    '.card-media',
    '.media--hover-effect',
    '.product-item__image',
    '.product-block__image',
    '.card__inner',
    '.image-wrap',
    '.product-image',
    'a.product-card__link',
    'a[href*="/products/"]'
  ];

  var MAIN_PRODUCT_SELECTORS = [
    '[data-pf-type="MediaMain2"]',
    '[data-pf-type="MediaMain"]',
    '.pf-main-media-wrapper',
    '.pf-main-media',
    '.product__media-item.is-active .product-media-container',
    '.product__media-item.is-initial .product-media-container',
    'media-gallery .product__media-list:not(.thumbnail-list) > .product__media-item:first-child .product-media-container',
    '.product__main-photos .product-media-container',
    '.product__main-photos .product__media',
    '.product__media-wrapper .product__media-item:first-child .product-media-container',
    '.product__modal-opener--image .product-media-container',
    '.product-single__photo',
    '.product-featured-media',
    '.product-single__media',
    '.product__media-gallery .product__media-item:first-child .product-media-container'
  ];

  var SOLD_OUT_SELECTORS = [
    '.badge--sold-out',
    '.badge-sold-out',
    '.card__badge--sold-out',
    '.sold-out',
    '.product-card__badge--sold-out',
    '[data-product-available="false"]',
    '.product-form__sold-out',
    '.price--sold-out'
  ];

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function nodeText(node) {
    if (!node) return '';
    return normalizeText(node.textContent || node.innerText || '');
  }

  function isInsideExcludedScope(node) {
    if (!node) return false;

    for (var i = 0; i < EXCLUDE_SCOPE_SELECTORS.length; i++) {
      if (node.closest(EXCLUDE_SCOPE_SELECTORS[i])) return true;
    }

    return false;
  }

  function isInsideThumbnail(node) {
    if (!node) return false;

    for (var i = 0; i < THUMB_PARENT_SELECTORS.length; i++) {
      if (node.closest(THUMB_PARENT_SELECTORS[i])) return true;
    }

    var el = node;
    while (el && el !== document.body) {
      var cls = (el.className || '').toString().toLowerCase();
      if (cls.indexOf('pf-list-media') !== -1 || cls.indexOf('pf-slide-list-media') !== -1) {
        return true;
      }
      if (
        cls.indexOf('thumbnail') !== -1 &&
        cls.indexOf('product__media-item') === -1
      ) {
        return true;
      }
      el = el.parentElement;
    }

    return false;
  }

  function isElementVisible(node) {
    if (!node || !node.getBoundingClientRect) return false;
    if (node.getAttribute('aria-hidden') === 'true' && !node.classList.contains('is-visible')) {
      return false;
    }

    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    var rect = node.getBoundingClientRect();
    return rect.width > 60 && rect.height > 60;
  }

  function isPageFlyListMedia(node) {
    return !!(
      node &&
      node.closest('[data-pf-type="MediaList2"], [data-pf-type="MediaListItem2"], .pf-list-media, .pf-slide-list-media')
    );
  }

  function isPageFlyMainType(node) {
    if (!node || !node.getAttribute) return false;
    var type = node.getAttribute('data-pf-type');
    return type === 'MediaMain' || type === 'MediaMain2';
  }

  function normalizePageFlyMedia(media) {
    if (!media || isPageFlyListMedia(media)) return null;

    if (
      media.classList &&
      (media.classList.contains('pf-slide-main-media') ||
        media.classList.contains('pf-media-slider') ||
        media.classList.contains('sc-kTbBOC'))
    ) {
      var wrapper = media.closest(
        '[data-pf-type="MediaMain2"], [data-pf-type="MediaMain"], .pf-main-media, .pf-main-media-wrapper'
      );
      if (wrapper && !isPageFlyListMedia(wrapper)) return wrapper;
    }

    if (isPageFlyMainType(media)) {
      return media.closest('.pf-main-media-wrapper') || media;
    }
    if (media.classList && media.classList.contains('pf-main-media-wrapper')) return media;
    if (media.classList && media.classList.contains('pf-main-media')) {
      return media.closest('.pf-main-media-wrapper') || media;
    }

    return media;
  }

  function findPageFlyMainMedia(scope) {
    var candidates = [];

    for (var i = 0; i < PAGEFLY_MAIN_SELECTORS.length; i++) {
      var nodes = scope.querySelectorAll(PAGEFLY_MAIN_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (isPageFlyListMedia(node)) continue;
        if (!isElementVisible(node)) continue;
        if (!node.querySelector('img, picture, video')) continue;
        candidates.push(normalizePageFlyMedia(node));
      }
    }

    candidates = candidates.filter(function (node, index, list) {
      return node && list.indexOf(node) === index;
    });

    if (candidates.length) return pickBestMedia(candidates);

    var activeSlide = scope.querySelector(
      '.pf-slide-main-media.is-current.is-visible, .pf-slide-main-media[data-active="true"], .pf-slide-main-media.is-current'
    );

    if (activeSlide && isElementVisible(activeSlide)) {
      return normalizePageFlyMedia(activeSlide);
    }

    return null;
  }

  function isProductPage() {
    if (/\/products\/[^/?#]+/.test(window.location.pathname)) return true;

    return !!(
      document.querySelector('product-info, [data-section-type="product"], .product-single, .product') ||
      (window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.page &&
        window.ShopifyAnalytics.meta.page.pageType === 'product')
    );
  }

  function getHandleFromUrl(url) {
    var value = url || window.location.pathname;
    var match = value.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getHandleFromCard(card) {
    if (!card) return null;

    var pfNodes = card.querySelectorAll('[data-href*="/products/"]');
    for (var i = 0; i < pfNodes.length; i++) {
      var handle = getHandleFromUrl(pfNodes[i].getAttribute('data-href') || '');
      if (handle) return handle;
    }

    if (card.getAttribute) {
      var fromCardHref = getHandleFromUrl(card.getAttribute('data-href') || '');
      if (fromCardHref) return fromCardHref;
    }

    var link = card.querySelector('a[href*="/products/"]');
    if (link) return getHandleFromUrl(link.getAttribute('href') || '');

    if (card.matches && card.matches('a[href*="/products/"]')) {
      return getHandleFromUrl(card.getAttribute('href') || '');
    }

    return null;
  }

  function getVisibleArea(node) {
    if (!node || !node.getBoundingClientRect) return 0;
    var rect = node.getBoundingClientRect();
    if (rect.width < 60 || rect.height < 60) return 0;
    return rect.width * rect.height;
  }

  function hasSoldOutBadge(card) {
    var badges = card.querySelectorAll(
      '.badge, .card__badge, .product-card__badge, .label, .tag, .status-badge, [class*="sold"]'
    );

    for (var i = 0; i < badges.length; i++) {
      if (SOLD_OUT_RE.test(nodeText(badges[i]))) return true;
    }

    return false;
  }

  function hasSoldOutButton(card) {
    var buttons = card.querySelectorAll(
      'button[name="add"], .product-form__submit, .btn--add-to-cart, [data-add-to-cart], .add-to-cart'
    );

    for (var j = 0; j < buttons.length; j++) {
      var btn = buttons[j];
      if (btn.disabled && SOLD_OUT_RE.test(nodeText(btn))) return true;
      if (SOLD_OUT_RE.test(btn.getAttribute('aria-label') || '')) return true;
    }

    return false;
  }

  function hasSoldOutMarker(card) {
    for (var i = 0; i < SOLD_OUT_SELECTORS.length; i++) {
      if (card.querySelector(SOLD_OUT_SELECTORS[i])) return true;
    }

    if (card.getAttribute('data-product-available') === 'false') return true;
    if (card.getAttribute('data-available') === 'false') return true;

    return hasSoldOutBadge(card) || hasSoldOutButton(card);
  }

  function findProductSectionRoot() {
    var pageFlyMedia = document.querySelector(
      '[data-pf-type="MediaMain2"], [data-pf-type="MediaMain"], .pf-main-media-wrapper, .product-media2-inner'
    );

    if (pageFlyMedia) {
      var fromPageFly = pageFlyMedia.closest(
        '[data-pf-type="Layout"], [data-pf-type="ProductBox"], .shopify-section, section, main'
      );
      if (fromPageFly && !isInsideExcludedScope(fromPageFly)) return fromPageFly;
    }

    var form = document.querySelector(
      'form[action*="/cart/add"], product-form, .product-form, [data-product-form], [data-type="add-to-cart-form"], [data-pf-type="ProductATC"]'
    );

    if (form) {
      var fromForm = form.closest(
        'product-info, [data-section-type="product"], #ProductSection, #product-section, .product-single, .product, .shopify-section--product, .shopify-section, section, [data-pf-type="Layout"]'
      );
      if (fromForm && !isInsideExcludedScope(fromForm)) return fromForm;
    }

    var title = document.querySelector(
      'h1.product__title, h1.product-title, h1[class*="product"], product-info h1, [data-section-type="product"] h1, [data-pf-type="ProductTitle"]'
    );

    if (title) {
      var fromTitle = title.closest(
        'product-info, [data-section-type="product"], #ProductSection, #product-section, .product-single, .product, .shopify-section--product, .shopify-section, section'
      );
      if (fromTitle && !isInsideExcludedScope(fromTitle)) return fromTitle;
    }

    var candidates = document.querySelectorAll(
      'product-info, [data-section-type="product"], #ProductSection, #product-section, .product-single, .product, .shopify-section--product'
    );

    for (var i = 0; i < candidates.length; i++) {
      if (!isInsideExcludedScope(candidates[i])) return candidates[i];
    }

    return document.querySelector('main') || document.body;
  }

  function findPageFlyCatalogCards(scope) {
    var cards = [];
    var seen = new Set();
    var mediaNodes = scope.querySelectorAll(
      '[data-pf-type="MediaMain2"][data-href*="/products/"], [data-pf-type="MediaMain"][data-href*="/products/"]'
    );

    for (var i = 0; i < mediaNodes.length; i++) {
      var mediaNode = mediaNodes[i];
      if (isInsideExcludedScope(mediaNode)) continue;
      if (!isElementVisible(mediaNode)) continue;

      var card = mediaNode;
      for (var s = 0; s < PAGEFLY_CARD_SELECTORS.length; s++) {
        var parent = mediaNode.closest(PAGEFLY_CARD_SELECTORS[s]);
        if (parent) {
          card = parent;
          break;
        }
      }

      card = mediaNode.closest('.pf-main-media-wrapper') || card;
      if (seen.has(card)) continue;
      seen.add(card);
      cards.push(card);
    }

    var wrappers = scope.querySelectorAll('.pf-main-media-wrapper');
    for (var j = 0; j < wrappers.length; j++) {
      var wrapper = wrappers[j];
      if (!wrapper.querySelector('[data-href*="/products/"], a[href*="/products/"]')) continue;
      if (isInsideExcludedScope(wrapper)) continue;
      if (!isElementVisible(wrapper)) continue;
      if (seen.has(wrapper)) continue;
      seen.add(wrapper);
      cards.push(wrapper);
    }

    return cards;
  }

  function isMainProductCard(card) {
    if (!isProductPage() || !card) return false;

    var productRoot = findProductSectionRoot();
    var mainMedia = findPageFlyMainMedia(productRoot) || findMainProductMedia(productRoot);
    if (!mainMedia) return false;

    return card === mainMedia || mainMedia.contains(card) || card.contains(mainMedia);
  }

  function findCards(root) {
    var cards = [];
    var seen = new Set();
    var scope = root || document;

    var pageFlyCards = findPageFlyCatalogCards(scope);
    for (var p = 0; p < pageFlyCards.length; p++) {
      if (!seen.has(pageFlyCards[p])) {
        seen.add(pageFlyCards[p]);
        cards.push(pageFlyCards[p]);
      }
    }

    for (var i = 0; i < CARD_SELECTORS.length; i++) {
      var nodes = scope.querySelectorAll(CARD_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (isInsideExcludedScope(node)) continue;
        if (!node.querySelector('img, picture, .media, [class*="media"]')) continue;
        if (seen.has(node)) continue;
        seen.add(node);
        cards.push(node);
      }
    }

    if (!cards.length) {
      var links = scope.querySelectorAll('a[href*="/products/"]');
      for (var k = 0; k < links.length; k++) {
        var link = links[k];
        if (!link.querySelector('img, picture')) continue;
        if (isInsideThumbnail(link)) continue;
        if (isInsideExcludedScope(link)) continue;
        var card =
          link.closest('li, article, .card, .product-card, .grid__item, .product-item, div') || link;
        if (seen.has(card)) continue;
        seen.add(card);
        cards.push(card);
      }
    }

    return cards;
  }

  function pickBestMedia(candidates) {
    if (!candidates.length) return null;

    for (var i = 0; i < candidates.length; i++) {
      if (isPageFlyMainType(candidates[i])) {
        return candidates[i].closest('.pf-main-media-wrapper') || candidates[i];
      }
    }

    for (var p = 0; p < candidates.length; p++) {
      if (candidates[p].classList && candidates[p].classList.contains('pf-main-media-wrapper')) {
        return candidates[p];
      }
    }

    for (var m = 0; m < candidates.length; m++) {
      if (candidates[m].classList && candidates[m].classList.contains('pf-main-media')) {
        return candidates[m];
      }
    }

    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].classList && candidates[i].classList.contains('card__media')) {
        return candidates[i];
      }
    }

    var best = null;
    var bestArea = 0;

    for (var j = 0; j < candidates.length; j++) {
      var candidate = candidates[j];
      var nested = false;

      for (var k = 0; k < candidates.length; k++) {
        if (candidate !== candidates[k] && candidates[k].contains(candidate)) {
          nested = true;
          break;
        }
      }

      if (nested) continue;
      if (!isElementVisible(candidate)) continue;

      var area = getVisibleArea(candidate);
      if (area > bestArea) {
        bestArea = area;
        best = candidate;
      }
    }

    return best || candidates[0];
  }

  function mediaFromImage(img) {
    if (!img || isInsideThumbnail(img) || isInsideExcludedScope(img)) return null;

    var media =
      img.closest(
        '[data-pf-type="MediaMain"], .pf-main-media-wrapper, .pf-main-media, .product-media-container, .product__media, .product-single__media, .product-featured-media, .product__modal-opener--image, .card__media, .card__inner, .product-card__image, .media, .image-wrap, a[href*="/products/"]'
      ) || img.parentElement;

    return normalizePageFlyMedia(media);
  }

  function findCatalogMedia(card) {
    if (card.classList && card.classList.contains('pf-main-media-wrapper')) {
      return normalizePageFlyMedia(card);
    }

    var pfMain = card.querySelector('[data-pf-type="MediaMain2"], [data-pf-type="MediaMain"]');
    if (pfMain) return normalizePageFlyMedia(pfMain);

    var candidates = [];

    for (var i = 0; i < CARD_MEDIA_SELECTORS.length; i++) {
      var matches = card.querySelectorAll(CARD_MEDIA_SELECTORS[i]);
      for (var j = 0; j < matches.length; j++) {
        var node = matches[j];
        if (isInsideThumbnail(node)) continue;
        if (isInsideExcludedScope(node)) continue;
        if (!node.querySelector('img, picture, video, .media')) continue;
        candidates.push(node);
      }
    }

    if (!candidates.length) {
      var img = card.querySelector('img, picture');
      var media = mediaFromImage(img);
      if (media) candidates.push(media);
    }

    return pickBestMedia(candidates);
  }

  function collectMediaCandidates(scope) {
    var candidates = [];
    var seen = new Set();

    function addCandidate(node) {
      if (!node || seen.has(node)) return;
      if (isInsideThumbnail(node)) return;
      if (isInsideExcludedScope(node)) return;
      if (!node.querySelector('img, picture, video, .media')) return;
      seen.add(node);
      candidates.push(node);
    }

    for (var i = 0; i < MAIN_PRODUCT_SELECTORS.length; i++) {
      var match = scope.querySelector(MAIN_PRODUCT_SELECTORS[i]);
      addCandidate(match);
    }

    var containers = scope.querySelectorAll(
      '.product-media-container, .product__media, .product-single__media, .product-featured-media, .product__modal-opener--image, .product-gallery, .product__main-photos, .product-image-main, [class*="product"][class*="image"], [class*="product"][class*="media"]'
    );

    for (var j = 0; j < containers.length; j++) {
      addCandidate(containers[j]);
    }

    var images = scope.querySelectorAll('img, picture');
    for (var k = 0; k < images.length; k++) {
      addCandidate(mediaFromImage(images[k]));
    }

    return candidates;
  }

  function findMainProductMedia(productRoot) {
    var scope = productRoot || findProductSectionRoot();
    var pageFlyMain = findPageFlyMainMedia(scope);
    if (pageFlyMain) return pageFlyMain;

    var candidates = collectMediaCandidates(scope);
    var best = pickBestMedia(candidates);
    if (best) return normalizePageFlyMedia(best);

    var gallery = scope.querySelector(
      'media-gallery, .product__media-gallery, .product__main-photos, .product-gallery, [class*="product-gallery"]'
    );

    if (gallery) {
      var galleryImg = gallery.querySelector('img, picture, video');
      var galleryMedia = mediaFromImage(galleryImg);
      if (galleryMedia) return galleryMedia;
    }

    return null;
  }

  function findMediaContainer(card, options) {
    options = options || {};

    if (options.mainOnly) {
      return findMainProductMedia(card);
    }

    return findCatalogMedia(card);
  }

  function removeOverlaysFromThumbnails(root) {
    var scope = root || document;
    var overlays = scope.querySelectorAll('.' + OVERLAY_CLASS);

    for (var i = 0; i < overlays.length; i++) {
      var overlay = overlays[i];
      var parent = overlay.parentElement;
      var misplaced =
        isInsideThumbnail(parent) ||
        isPageFlyListMedia(parent) ||
        (parent && parent.classList && parent.classList.contains('pf-slide-main-media')) ||
        (parent && parent.classList && parent.classList.contains('pf-slide-list-media')) ||
        isInsideExcludedScope(parent) ||
        (isProductPage() &&
          parent &&
          !findProductSectionRoot().contains(parent) &&
          !findCards(document).some(function (card) {
            return card.contains(parent);
          }));

      if (misplaced) {
        if (parent) parent.classList.remove(MEDIA_CLASS);
        overlay.remove();
      }
    }
  }

  function ensureOverlay(media, options) {
    options = options || {};
    media = normalizePageFlyMedia(media);
    if (!media || isInsideThumbnail(media) || isPageFlyListMedia(media) || isInsideExcludedScope(media)) {
      return false;
    }
    if (!isElementVisible(media)) return false;

    if (media.querySelector('.' + OVERLAY_CLASS)) {
      media.classList.add(MEDIA_CLASS);
      return false;
    }

    media.classList.add(MEDIA_CLASS);

    var overlay = document.createElement('span');
    overlay.className = OVERLAY_CLASS;
    if (options.hero) overlay.classList.add('pa-agotado-overlay--hero');
    if (options.card) overlay.classList.add('pa-agotado-overlay--card');
    overlay.setAttribute('aria-label', 'Producto agotado');
    overlay.textContent = 'AGOTADO';
    media.appendChild(overlay);

    return true;
  }

  function readAvailabilityFromPage(productRoot) {
    if (hasSoldOutMarker(productRoot)) return false;

    var addButton = productRoot.querySelector(
      'button[name="add"], .product-form__submit, [data-add-to-cart], .add-to-cart'
    );
    if (addButton && addButton.disabled && SOLD_OUT_RE.test(nodeText(addButton))) {
      return false;
    }

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.available !== false;
    }

    if (window.meta && window.meta.product && typeof window.meta.product.available !== 'undefined') {
      return window.meta.product.available !== false;
    }

    var scripts = productRoot.querySelectorAll('script[type="application/json"], script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && typeof data.available === 'boolean') return data.available;
        if (data && data['@type'] === 'Product' && data.offers) {
          var offers = Array.isArray(data.offers) ? data.offers[0] : data.offers;
          if (offers && typeof offers.availability === 'string') {
            return offers.availability.indexOf('OutOfStock') === -1;
          }
        }
      } catch (e) {
        /* ignore */
      }
    }

    return null;
  }

  function fetchAvailability(handle) {
    if (!handle) return Promise.resolve(null);
    if (availabilityCache.hasOwnProperty(handle)) {
      return Promise.resolve(availabilityCache[handle]);
    }
    if (pendingHandles[handle]) return pendingHandles[handle];

    pendingHandles[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var available = data && typeof data.available === 'boolean' ? data.available : null;
        availabilityCache[handle] = available;
        delete pendingHandles[handle];
        return available;
      })
      .catch(function () {
        availabilityCache[handle] = null;
        delete pendingHandles[handle];
        return null;
      });

    return pendingHandles[handle];
  }

  function applyProductPage() {
    if (!isProductPage()) return Promise.resolve(0);

    var productRoot = findProductSectionRoot();
    var handle = getHandleFromUrl();

    function finish(available) {
      if (available !== false) return 0;
      removeOverlaysFromThumbnails(productRoot);
      var mainMedia = findMainProductMedia(productRoot);
      return ensureOverlay(mainMedia, { hero: true }) ? 1 : 0;
    }

    var fromPage = readAvailabilityFromPage(productRoot);
    if (fromPage === false) return Promise.resolve(finish(false));
    if (fromPage === true) return Promise.resolve(0);

    if (!handle) return Promise.resolve(0);

    return fetchAvailability(handle).then(function (available) {
      return finish(available);
    });
  }

  function applyToCard(card) {
    if (isMainProductCard(card)) return Promise.resolve(0);

    function applyIfSoldOut(available) {
      if (available !== false) return 0;
      return ensureOverlay(findMediaContainer(card), { card: true }) ? 1 : 0;
    }

    if (hasSoldOutMarker(card)) {
      return Promise.resolve(applyIfSoldOut(false));
    }

    var handle = getHandleFromCard(card);
    if (!handle) return Promise.resolve(0);

    return fetchAvailability(handle).then(applyIfSoldOut);
  }

  function applyAll(root) {
    var scope = root || document;
    removeOverlaysFromThumbnails(scope);

    var tasks = [];
    var cards = findCards(scope);

    for (var i = 0; i < cards.length; i++) {
      tasks.push(applyToCard(cards[i]));
    }

    if (!root || root === document) {
      tasks.push(applyProductPage());
    }

    return Promise.all(tasks).then(function (results) {
      var count = 0;
      for (var j = 0; j < results.length; j++) count += results[j] || 0;
      return count;
    });
  }

  function boot() {
    applyAll(document);
  }

  window.ProductAgotado = {
    refresh: applyAll,
    findMainProductMedia: function () {
      return findMainProductMedia(findProductSectionRoot());
    },
    getProductSection: findProductSectionRoot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function (event) {
    applyAll(event.target || document);
  });

  if (window.MutationObserver) {
    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
          shouldRefresh = true;
          break;
        }
        if (
          mutation.type === 'attributes' &&
          (mutation.attributeName === 'class' || mutation.attributeName === 'hidden')
        ) {
          shouldRefresh = true;
          break;
        }
      }

      if (!shouldRefresh) return;

      clearTimeout(timer);
      timer = setTimeout(boot, 150);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden']
    });
  }
})();